import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useEffect } from 'react';
import { Form, Search } from 'semantic-ui-react';
import useDebounce from '../../hooks/use-debounce';
import { searchPlace, placeDetails } from '../../utils/api';
import { USPS_STATE_CODES } from '../AddressForm/AddressForm.constants';
import './AddressSearchForm.css';
var defaultProps = {
  label: 'Address',
  required: false
};
function AddressSearchForm(_ref) {
  var onSelect = _ref.onSelect,
    label = _ref.label,
    required = _ref.required;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    query = _useState6[0],
    setQuery = _useState6[1];
  var debouncedQuery = useDebounce(query, 300);
  var placeholder = 'Start typing to find your address';
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var resultsResponse, formattedResults;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (debouncedQuery) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          setIsLoading(true);
          _context.prev = 3;
          _context.next = 6;
          return searchPlace(query);
        case 6:
          resultsResponse = _context.sent;
          formattedResults = resultsResponse.data.map(function (placeData) {
            return {
              key: placeData.place_id,
              value: placeData.place_id,
              description: placeData.description,
              title: placeData.structured_formatting.main_text
            };
          });
          setOptions(formattedResults);
        case 9:
          _context.prev = 9;
          setIsLoading(false);
          return _context.finish(9);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3,, 9, 12]]);
  })), [debouncedQuery]);
  function onSearchChange(_, _ref3) {
    var value = _ref3.value;
    setQuery(value);
  }
  function onResultSelect(_x, _x2) {
    return _onResultSelect.apply(this, arguments);
  }
  function _onResultSelect() {
    _onResultSelect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_, _ref4) {
      var result, placeId, resultsResponse, _resultsResponse$data, state, city, postalCode, street;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            result = _ref4.result;
            placeId = result.value;
            setIsLoading(true);
            _context2.prev = 3;
            _context2.next = 6;
            return placeDetails(placeId);
          case 6:
            resultsResponse = _context2.sent;
            _resultsResponse$data = resultsResponse.data, state = _resultsResponse$data.state, city = _resultsResponse$data.city, postalCode = _resultsResponse$data.postal_code, street = _resultsResponse$data.street; // TODO support other countries other than USA
            onSelect({
              state: USPS_STATE_CODES.includes(state) ? state : '',
              city: city,
              postalCode: postalCode,
              line1: street
            });
          case 9:
            _context2.prev = 9;
            setIsLoading(false);
            return _context2.finish(9);
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3,, 9, 12]]);
    }));
    return _onResultSelect.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Field, {
    required: required
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "address-search-form"
  }, label), /*#__PURE__*/React.createElement(Search, {
    id: "address-search-form",
    className: "address-search-form",
    aligned: "left",
    placeholder: placeholder,
    loading: isLoading,
    onSearchChange: onSearchChange,
    onResultSelect: onResultSelect,
    value: query,
    results: options,
    selectFirstResult: true
  })));
}
AddressSearchForm.defaultProps = defaultProps;
export default AddressSearchForm;